var getAccessToken = function () {
    return sessionStorage.getItem('accessToken');
};
export default getAccessToken;
//# sourceMappingURL=getaccessToken.js.map